import React, { useEffect, useState } from "react";
import { Typography, Grid, Card, CardContent, Radio, FormControl, FormLabel, FormControlLabel, RadioGroup } from "@deere/fuel-react";
import SelfServiceButtons from "../SelfServiceButtons";
import { STATUS_COMPLETED, STATUS_DRAFT } from "../../../../utils/surveyLiterals";
import SelfServiceLoader from "../SelfServiceLoader";

const SaveOrPublishStep = ({ currentStep, activeStep, setActiveStep, setPayloadData, payloadData }) => {
  const [loader, setLoader] = useState({isLoading: false, message: ""});
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  useEffect(() => {
    return () =>
      setPayloadData((prevState) => {
        return { ...prevState, templateStatus: STATUS_DRAFT, active: false };
      });
  }, []);

  return (
    <Card>
      <CardContent>
        {loader.message !== "" && <SelfServiceLoader loader={loader} />}
        {loader.message === "" && <Grid container direction="column" justifyContent="space-between" minHeight={"60vh"} rowSpacing={4}>
          <Grid item>
            <Typography variant="h1">
              {currentStep.step} - {currentStep.title}
            </Typography>
          </Grid>
          <Grid item pl={5} pr={5}>
            <FormControl sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
              <FormLabel>What do you want to do ?</FormLabel>
              <RadioGroup>
                <FormControlLabel
                  control={<Radio />}
                  label="Keep my survey in draft"
                  name="payloadStatus"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
                  checked={!payloadData.active}
                  onChange={() =>
                    setPayloadData((prevState) => {
                      return { ...prevState, templateStatus: STATUS_DRAFT, active: false };
                    })
                  }
                />
                <FormControlLabel
                  control={<Radio />}
                  label="Publish and activate"
                  name="payloadStatus"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
                  checked={payloadData.active}
                  onChange={() =>
                    setPayloadData((prevState) => {
                      return { ...prevState, templateStatus: STATUS_COMPLETED, active: true };
                    })
                  }
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item pr={5}>
            <Grid container justifyContent="flex-end">
              <SelfServiceButtons activeStep={activeStep} setActiveStep={setActiveStep} payloadData={payloadData} setPayloadData={setPayloadData} setLoader={setLoader} showSubmitModal={showSubmitModal} setShowSubmitModal={setShowSubmitModal} />
            </Grid>
          </Grid>
        </Grid>}
      </CardContent>
    </Card>
  );
};

export default SaveOrPublishStep;
